import { List as SemanticList } from 'semantic-ui-react';

export { ListProps, StrictListProps } from 'semantic-ui-react';

export const List: typeof SemanticList = SemanticList;

export default List;
